export enum AutogiroMandateSourceEnum {
  BankID = 10,
  Bank = 20,
  Paper = 30,
  Unknown = 0,
}
